module.exports = __webpack_public_path__ + "img/question.12c52567.png";